module.exports = __webpack_public_path__ + "static/media/undraw_positive_attitude_xaae.f1347d6d.svg";